import { createSlice } from "@reduxjs/toolkit";
import { getStationViewByIdApi } from "../../actions/stations/getStationViewById";

const initialState = {
  stationViewById: {},
  loading: false,
  error: null,
};

const stationViewByIdSlice = createSlice({
  name: "getStationViewById",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStationViewByIdApi.pending, (state, action) => {
        state.stationViewById = initialState.stationViewById;
        state.loading = true;
      })
      .addCase(getStationViewByIdApi.fulfilled, (state, action) => {
        state.stationViewById = action.payload.user;
        state.loading = false;
      })
      .addCase(getStationViewByIdApi.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export default stationViewByIdSlice.reducer;
